import React, { useContext, useEffect, useState } from 'react';
import { Button, CircularProgress, Typography } from "@material-ui/core"
import PaymentForm from '../components/PaymentForm'
import { useHistory, useParams } from "react-router-dom";
import {AppContext} from "../AppContext";
import {MessageContext} from "../MessageContext";
import moment from 'moment';

function EventShowPage(props) {

    const {eventId} = useParams()
    const [showSquare, setShowSquare] = useState(false)
    const [selectedEvent, setSelectedEvent] = useState(null)
    const [registrationClicked, setRegistrationClicked] = useState(false)

    const context = useContext(AppContext)
    const messageContext = useContext(MessageContext)

    const history = useHistory();

    const {updateCurrentEvent} = props

    const dayFormat = 'MM/DD/YYYY hh:mm a'

    const start = selectedEvent ? moment(selectedEvent.start_time).format(dayFormat) : null
    const end = selectedEvent ? moment(selectedEvent.finish_time).format(dayFormat) : null

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_CALL}/events/${eventId}`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(event => {
                setSelectedEvent(event)
                updateCurrentEvent(event)
            })
    }, [eventId, updateCurrentEvent])

    useEffect(() => {
        let sqPaymentScript = document.createElement('script');
        sqPaymentScript.src = "https://js.squareupsandbox.com/v2/paymentform";
        sqPaymentScript.type = "text/javascript"
        sqPaymentScript.async = false;
        sqPaymentScript.onload = () => {
            setShowSquare(false)
        };
        document.getElementsByTagName("head")[0].appendChild(sqPaymentScript);
    }, [])

    const registerForEvent = () => {
        fetch(`${process.env.REACT_APP_API_CALL}/user_events`, {
            method: "POST",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                user_id: context.currentUser.id,
                event_id: selectedEvent.id,
            })
        })
            .then(response => response.json())
            .then(response => {
                if (response.errors) {
                    alert(response.errors)
                } else {
                    messageContext.showSuccessMessage("Event registration successful!")
                    history.push("/")
                }
            })
    }

    const signupUserForEvent = (nonce) => {

        fetch(`${process.env.REACT_APP_API_CALL}/process-payment`, {
            method: "POST",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                nonce: nonce,
                amount: selectedEvent.price
            })
        })
            .then(response => response.json())
            .then(response => {
                if (response.success) {
                    registerForEvent()
                }
                else {
                    alert("Payment failed")
                }
            })
    }

    const handleRegistration = (e) => {
        e.preventDefault()

        setRegistrationClicked(true)

        if (selectedEvent.price === 0) {
            registerForEvent()
        } else {
            setShowSquare(true)
        }
    }

    console.log(selectedEvent)
        
    return (
        <div >

            {selectedEvent ? 
                <div className="events-block">
                    <div className="event-info">
                        <Typography variant="h3">{selectedEvent.name}</Typography><br/>
                        <Typography>Event Details</Typography>
                        <Typography>Start: {start} {selectedEvent.timezone}</Typography>
                        <Typography>End: {end} {selectedEvent.timezone}</Typography>
                        <Typography>Description: {selectedEvent.description}</Typography>
                        <Typography>Price: {selectedEvent.price}</Typography>
                        <br></br>
                        <Button onClick={() => {history.push("/allEvents")}} variant="outlined">Go Back</Button>
                        {
                            !registrationClicked && 
                            <Button id="event-registration-button"variant="contained" color="primary" onClick={(e) => handleRegistration(e)}>Register</Button>
                        }
                    </div>
                

                    {showSquare && <PaymentForm
                    signupUserForEvent={signupUserForEvent}
                    paymentForm={window.SqPaymentForm}/>}


                </div>

             : 
                <CircularProgress/>
            }

        </div>
    )
}

export default EventShowPage
